import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Metadados from './Metadados';
import AcervoCartograficoMunicipalRoutes from './AcervoCartograficoMunicipal/routes';
import AprovacaoDeProjetosRoutes from './AprovacaoDeProjetos/routes';
import DivinopolisEmDados from './DivinopolisEmDados';
import LegislacaoUrbanistica from './LegislacaoUrbanistica';
import MapotecaDigitalRoutes from './MapotecaDigital/routes';
import InfoBasicaZoneamento from './InfoBasicaZoneamento';
// import TransferenciaDeDados from './TransferenciaDeDados';
import Tutoriais from './Tutoriais';

function Media() {
	return (
		<Switch>
			<Route
				path="/media/legislacao-urbanistica"
				component={LegislacaoUrbanistica}
			/>
			<Route
				path="/media/mapoteca-digital"
				component={MapotecaDigitalRoutes}
			/>
			<Route
				path="/media/aprovacao-de-projetos"
				component={AprovacaoDeProjetosRoutes}
			/>
			<Route
				path="/media/divinopolis-em-dados"
				component={DivinopolisEmDados}
			/>
			 
			<Route
				path="/media/info-basica-zoneamento"
				component={InfoBasicaZoneamento}
			/>
			<Route
				path="/media/acervo-cartografico-municipal"
				component={AcervoCartograficoMunicipalRoutes}
			/>
			<Route path="/media/tutoriais" component={Tutoriais} />
			{/* <Route
				path="/media/transferencia-de-dados"
				component={TransferenciaDeDados}
			/> */}
			<Route path="/media/metadados" component={Metadados} />
			<Redirect from="/media" to="/media/legislacao-urbanistica" />
		</Switch>
	);
}

export default Media;
